export function normalizeContactEmail(email: string | undefined | null): string {
  return String(email || '').trim().toLowerCase();
}

export interface ContactEmailIdentity {
  id?: string;
  customer_id: string;
  name: string;
  email?: string;
  status?: 'active' | 'inactive' | string | null;
}

/** 未標註狀態的舊資料視為在職。 */
export function isContactActive(contact: { status?: string | null }): boolean {
  return contact.status !== 'inactive';
}

export function contactStatusLabel(status?: string | null): string {
  return status === 'inactive' ? '離職' : '在職';
}

/**
 * 同一客戶下，在職聯絡人 email（忽略大小寫與前後空白）不可重複。
 * 離職（inactive）與空白 email 不列入比對，以便接任者沿用同一信箱。
 */
export function findDuplicateContact(
  contacts: ContactEmailIdentity[],
  candidate: { customer_id: string; email?: string },
  excludeId?: string | null
): ContactEmailIdentity | null {
  const email = normalizeContactEmail(candidate.email);
  if (!email || !candidate.customer_id) {
    return null;
  }

  return (
    contacts.find(
      (contact) =>
        contact.id !== excludeId &&
        isContactActive(contact) &&
        contact.customer_id === candidate.customer_id &&
        normalizeContactEmail(contact.email) === email
    ) || null
  );
}

export function duplicateContactEmailMessage(existing: { name: string }): string {
  return `此郵件的聯絡人已存在：${existing.name}`;
}
